// extracted by mini-css-extract-plugin
module.exports = {"yearSVG":"style-module--yearSVG--1Yj2g"};